<script setup lang="ts">
import { computed } from 'vue'
import { useAuthStore } from '../stores/auth'

const auth = useAuthStore()
const firstName = computed(() => auth.user?.display_name?.split(' ')[0] || 'CasaMB')
const isAndrea = computed(() => auth.user?.persona === 'king')
const navItems = computed(() => [
  { to: '/', icon: '⌂', label: 'Dashboard' },
  { to: '/menu', icon: '▦', label: 'Menu settimanale' },
  { to: '/shopping', icon: '⌑', label: 'Spesa' },
  { to: '/pantry', icon: '▤', label: 'Dispensa' },
  { to: '/recipes', icon: '♨', label: 'Ricette' },
  { to: '/leftovers', icon: '◫', label: 'Avanzi' },
  { to: '/notifications', icon: '◌', label: 'Notifiche' },
  { to: '/downloads', icon: '⇩', label: 'Scarica app' },
  ...(auth.isAdmin ? [{ to: '/admin', icon: '⚙', label: 'Amministrazione' }] : []),
])
</script>

<template>
  <div class="app-layout">
    <aside class="sidebar">
      <RouterLink class="brand" to="/" aria-label="CasaMB home">
        <img src="/brand/casamb-favicon-source.png" alt="" class="brand-logo" />
        <div>
          <strong>CasaMB</strong>
          <small>La casa, insieme.</small>
        </div>
      </RouterLink>

      <nav aria-label="Navigazione principale">
        <RouterLink v-for="item in navItems" :key="item.to" :to="item.to">
          <span class="nav-icon" aria-hidden="true">{{ item.icon }}</span>
          <span>{{ item.label }}</span>
        </RouterLink>
      </nav>

      <div class="sidebar-quote">
        <span class="quote-heart">♥</span>
        <p>Le piccole cose fatte insieme rendono la casa un posto migliore.</p>
        <span class="quote-leaf">⌇</span>
      </div>
    </aside>

    <section class="workspace">
      <header class="topbar">
        <div class="topbar-copy">
          <p class="eyebrow">CasaMB</p>
          <h1>Ciao {{ firstName }}! <span aria-hidden="true">👋</span></h1>
          <p>Ecco cosa succede in casa oggi.</p>
        </div>

        <div class="household-profiles" aria-label="Profili della casa">
          <div class="profile-chip" :class="{ active: isAndrea }">
            <img src="/brand/andrea-king.png" alt="Avatar di Andrea" />
            <span><strong>Andrea <b class="profile-symbol">♛</b></strong><small>Il Re</small></span>
          </div>
          <div class="profile-chip marika" :class="{ active: !isAndrea }">
            <img src="/brand/marika-cambusiera.png" alt="Avatar di Marika" />
            <span><strong>Marika <b class="profile-symbol">♡</b></strong><small>La Cambusiera</small></span>
          </div>
          <button class="logout-button" title="Esci" @click="auth.logout()">Esci</button>
        </div>
      </header>

      <main class="content"><slot /></main>
    </section>
  </div>
</template>
